import React, { useState } from 'react';
import { sendContactForm, UserInfo } from '../Utility/sharedFunctions';
import '../CSS/ContactUs.css';

const ContactUs: React.FC = () => {
  const [formData, setFormData] = useState<UserInfo>({
    name: '',
    email: '',
    phoneNumber: '',
    inquiry: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMessage, setErrorMessage] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');
    setErrorMessage('');

    try {
      await sendContactForm(formData);
      setSubmitStatus('success');
      setFormData({
        name: '',
        email: '',
        phoneNumber: '',
        inquiry: '',
        message: ''
      });
    } catch (error) {
      setSubmitStatus('error');
      setErrorMessage(error instanceof Error ? error.message : 'Failed to send message');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-us-page">
      <div className="contact_hero">
        <div className="banner-overlay"></div>
        <div className="banner-content">
          <h1 className="banner-title">Reach Out to Us Today!</h1>
          <p className="banner-subtitle">Our team is ready to help you move forward with the right solution. Let us know a bit about you, and we'll connect shortly!</p>
        </div>
      </div>

      <div className="contact_form_section">
        <div className="contact-form-container">
          <h2 className="form-title">Fill out the form</h2>
          
                    {submitStatus === 'success' && (
            <div className="contactus-success-message">
              Thank you! Your message has been sent successfully. We'll get back to you soon.
            </div>
          )}

          {submitStatus === 'error' && (
            <div className="contactus-error-message">
              {errorMessage}
            </div>
          )}

          <form className="contactus-form desktop-contactus-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-field">
                <input 
                  type="text" 
                  name="name"
                  placeholder="Your Name" 
                  className="form-input" 
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-field">
                <input 
                  type="email" 
                  name="email"
                  placeholder="Email" 
                  className="form-input" 
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-field">
                <input 
                  type="tel" 
                  name="phoneNumber"
                  placeholder="Phone" 
                  className="form-input" 
                  value={formData.phoneNumber}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-field">
                <select 
                  name="inquiry"
                  className="form-input form-select"
                  value={formData.inquiry}
                  onChange={handleInputChange}
                  required
                >
                  <option value="" disabled>Inquiry</option>
                  <option value="Artificial Intelligence">Artificial Intelligence</option>
                  <option value="Data Engineering">Data Engineering</option>
                  <option value="Generative AI">Generative AI</option>
                  <option value="Software Engineering">Software Engineering</option>
                  <option value="General Inquiry">General Inquiry</option>
                </select>
              </div>
            </div>
            <div className="form-row">
              <div className="form-field full-width">
                <textarea 
                  name="message"
                  placeholder="Message" 
                  className="form-input form-textarea"
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                ></textarea>
              </div>
            </div>
            <div className="form-row">
              <div className="form-field full-width">
                <button 
                  type="submit" 
                  className="submit-button"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Sending...' : 'Make a Request'}
                </button>
              </div>
            </div>
          </form>

          {/* Mobile Contact Form */}
                       <form className="contactus-form contactus-mobile-form" onSubmit={handleSubmit}>
               <input 
                 type="text" 
                 name="name"
                 placeholder="Your Name" 
                 className="form-input contactus-mobile-form-input" 
                 value={formData.name}
                 onChange={handleInputChange}
                 required
               />
               <input 
                 type="email" 
                 name="email"
                 placeholder="Email" 
                 className="form-input contactus-mobile-form-input" 
                 value={formData.email}
                 onChange={handleInputChange}
                 required
               />
               <input 
                 type="tel" 
                 name="phoneNumber"
                 placeholder="Phone" 
                 className="form-input contactus-mobile-form-input" 
                 value={formData.phoneNumber}
                 onChange={handleInputChange}
                 required
               />
               <select 
                 name="inquiry"
                 className="form-input form-select contactus-mobile-form-select"
                 value={formData.inquiry}
                 onChange={handleInputChange}
                 required
               >
                <option value="" disabled>Inquiry</option>
                <option value="Artificial Intelligence">Artificial Intelligence</option>
                <option value="Data Engineering">Data Engineering</option>
                <option value="Generative AI">Generative AI</option>
                <option value="Software Engineering">Software Engineering</option>
                <option value="General Inquiry">General Inquiry</option>
               </select>
               <textarea 
                 name="message"
                 placeholder="Message" 
                 className="form-input form-textarea contactus-mobile-form-textarea"
                 value={formData.message}
                 onChange={handleInputChange}
                 required
               ></textarea>
               <button 
                 type="submit" 
                 className="submit-button contactus-mobile-submit-button"
                 disabled={isSubmitting}
               >
                 {isSubmitting ? 'Sending...' : 'Make a Request'}
               </button>
             </form>
        </div>
      </div>
    </div>
  );
};

export default ContactUs; 